export const FilterButton = "padding: 2px 10px; filter: brightness(0.5); margin: 3px 3px;";
export const FilterButtonSelected = "padding: 2px 10px; margin: 3px 3px;";
